import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bng-bulmangular',
  template: `
    <p>
      bulmangular works!
    </p>
  `,
  styles: [
  ]
})
export class BulmangularComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
